import { PillButton } from '@rocco/components/pill-button';

export interface RefineBrowseModeOption {
    label: string;
    isActive: boolean;
    /** Switches to this mode. Navigates, so the sheet closes. */
    onSelect: () => void;
}

export interface RefineBrowseModeConfig {
    /**
     * The modes, in a fixed order. Order must not depend on which one is
     * active, or the pills reshuffle under the user's finger when they switch.
     */
    options: RefineBrowseModeOption[];
}

/**
 * Browse-mode switch for the refine sheet — the mobile counterpart of the
 * "Prefer to browse by …" prompt beside the desktop grid heading.
 *
 * Unlike the other sections this commits immediately rather than staging into
 * local filter states: the two modes have different filter sets entirely, so
 * there is nothing to carry across and staging it alongside filters that are
 * about to be discarded would be misleading.
 */
export const RefineBrowseModePills = ({ options }: RefineBrowseModeConfig) => {
    if (options.length === 0) return null;

    return (
        <section aria-label="Browse mode">
            <div className="flex min-h-11 items-center text-base font-medium">
                Browse mode
            </div>
            <div
                role="radiogroup"
                aria-label="Browse mode"
                className="-mx-6 flex scrollbar-hidden gap-2 overflow-x-auto px-6 pb-3"
            >
                {options.map((option) => (
                    <PillButton
                        key={option.label}
                        role="radio"
                        aria-checked={option.isActive}
                        size="sm"
                        selected={option.isActive}
                        className="shrink-0"
                        onClick={option.isActive ? undefined : option.onSelect}
                    >
                        {option.label}
                    </PillButton>
                ))}
            </div>
        </section>
    );
};
